import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import { HideableTextFormField } from '../../../components/FormCom/HideableTextFormField';
import useSignin from '../../../hooks/auth/admin/useSignin';
import {
  SignInDataType,
  signinInitialValues,
  SignInSchema,
} from '../../../models/auth/signIn.model';

const SignInForm = () => {
  const navigate = useNavigate();
  const { loading, signin } = useSignin();

  const onSubmit = (value: SignInDataType) => {
    signin(value);
  };

  const onForgotPassword = () => {
    navigate('/account/forgot-password');
  };

  return (
    <FormComponent
      initialValues={signinInitialValues}
      schema={SignInSchema}
      onSubmit={onSubmit}
    >
      <TextInputField
        label='Email'
        name='email'
        id='email'
        type='email'
        placeholder='Email'
      />

      <HideableTextFormField
        label='Password'
        name='password'
        type='password'
        id='password'
        placeholder='Password'
      />

      <ForgotPasswordText onClick={onForgotPassword}>
        Forgot password?
      </ForgotPasswordText>

      <FormSubmitButton loading={loading} className='topMargin large'>
        Sign In
      </FormSubmitButton>
    </FormComponent>
  );
};

export default SignInForm;

const ForgotPasswordText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.blueColor};
  cursor: pointer;
  align-self: flex-end;
  margin-top: -20px;
  width: fit-content;

  @media (max-width: 884px) {
    text-align: right;
    margin-left: auto;
  }
`;
